import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
 
export interface ModificationBookingProps extends BaseComponentProps {
    lang: string; 
    history?: History;
}

export interface ModificationBookingState extends BaseComponentState { }

export class ModificationBooking extends BaseComponent<ModificationBookingProps, ModificationBookingState> {

    constructor(props: ModificationBookingProps) {
        super(props); 
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let page = <span />; 

        return (
            <div>
                {page}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/ModificationBooking.tsx